// method to access path to a given asset name
export const pathToAsset = {

    methods: {
        pathToAsset( asset ){
            return require( `@/assets/${asset}` )
        }
    }

}